import {
  DETECT_MOBILE,
  DOWNLOAD_PAGE_IN,
  useLightBoxLoginContext,
} from 'components/light-box-login/use-light-box-login';
import styles from 'components/light-box-login/index.module.scss';
import { Button, FormInput, Select } from 'mochi-react-component';
import React from 'react';
import classnames from 'classnames/bind';

const LoginStep = () => {
  const cx = classnames.bind(styles);
  const { state, dispatch, onSendMobile, changingDistributor } = useLightBoxLoginContext();

  const onDetectMobile = e => {
    dispatch({
      type: DETECT_MOBILE,
      payload: e,
    });
  };

  const onDownloadPageIn = () => {
    dispatch({
      type: DOWNLOAD_PAGE_IN,
    });
  };

  const stepMobileClass = cx({
    step: true,
    'step-mobile': true,
    out: state.mobilePageOut,
  });
  const distributorOptions = {
    LINE_BANK: 'LINE Bank',
    CPCPAY: '中油 Pay',
    NPCPAY: '全國加油站',
    MYTOYOTA: 'My Toyota',
    LEXUS_PLUS: 'LEXUS Plus',
    IKNOW99: '愛車 99',
    WAFFLE: '窩福社區',
    CATHAYMR: '國泰優惠',
    AUTO_PARTNER: 'Auto Partner',
    AUTOPASS: '車麻吉',
  };

  return (
    <div className={stepMobileClass}>
      <div className={styles.title}>歡迎回來</div>
      <div className={styles.desc}>登入你的麻吉付帳號，查看帳號設定。</div>
      <div className={styles.select}>
        <Select
          data={distributorOptions}
          selectedValue={'車麻吉'}
          onSelect={key => {
            changingDistributor(key);
          }}
        />
      </div>
      <div className={styles.input}>
        <FormInput
          type="tel"
          label="手機號碼"
          placeholder="請輸入手機號碼"
          newText={state.mobile}
          maxLength={10}
          errorMsg=""
          onTextChange={onDetectMobile}
          onKeyDown={e => {
            if (e.which === 9) {
              e.preventDefault();
            }
          }}
          onKeyPress={() => {
            if (state.mobileAvailable) {
              onSendMobile();
            }
          }}
        />
        <div className={styles.button}>
          <Button
            theme="black"
            disabled={!state.mobileAvailable}
            onClick={() => {
              onSendMobile();
            }}
          >
            傳送驗證碼
          </Button>
        </div>
      </div>
      <div className={styles.else}>
        還未成為麻吉付一員嗎？
        <br />
        在支援平台完成註冊，即可開始行車輕鬆付。
        <Button type="text" theme="blue" onClick={onDownloadPageIn}>
          立即使用
        </Button>
      </div>
    </div>
  );
};

export default LoginStep;
